import { Component, Input } from '@angular/core';
//shared libs
import { StepperComponent } from '../../blocks';

@Component({
    selector: 'cashierTransCover',
    templateUrl: 'cashier-trans-cover.component.html'
})
export class CashierTransCoverComponent {
    @Input() bannerType: number;
    @Input() transType: number;
    @Input() mode: number;
    @Input() myStepNumber: number;
    @Input() stepperComponent: StepperComponent;
    constructor() { }
}

